<template>
  <div class="page">
    <div class="tops-title">
      <p class="p16">验劵核销</p>
    </div>
    <div class="page-head">
      <div class="mains-content">
        <div class="pt16 pl16"><el-button type="primary" class="mb16" @click="orderClick">核销记录</el-button></div>
        <div class="flex-row box-scroll plr16">
          <div v-for="item in list" :key="item.payWayCode" class="item-box" @click="skip(item)">
            <img :src="item.iconUrl" alt="">
            <span class="fontSize16 fb">{{item.menuName}}</span>
          </div>
        </div>
        <tips :type="'useConfirm'"></tips>
      </div>
    </div>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import tips from "../../../components/tips";
export default {
  mixins: [minxin],
  data() {
    return {
      list: [],
      url: this.$url.order.thirdConfirmMenu
    };
  },
  components: {tips},
  created() {
    this.getData();
  },
  methods: {
    skip (item) {
      console.log(item);
      this.$router.push({
        path: '/collectMoney/verification',
        query: {
          payWayCode: item.payWayCode,
          menuName: item.menuName,
          appName: item.appName,
          menuCode: item.menuCode
        }
      });
      sessionStorage.setItem("verification", JSON.stringify({
          payWayCode: item.payWayCode,
          menuName: item.menuName,
          appName: item.appName,
          menuCode: item.menuCode
        }))
    },
    orderClick () {
      this.$router.push('/collectMoney/verificationRecords');
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
* {
  box-sizing: border-box;
}
.page-head {
  .item-box {
    width: calc(24% - 40px);
    margin-right: 1%;
    display: flex;
    align-items: center;
    height: 134px;
    padding: 20px;
    border: 1px solid #EEEEEE;
    border-radius: 10px;
    cursor: pointer;
    img {
      width: 74px;
      height: 74px;
      border-radius: 10px;
      margin-right: 20px;
    }
  }
}
.mains-bottoms {
  width: 100%;
  position: relative;
  background-color: #fff;
  margin-top: 10px;
  .back {
    margin: 10px 20px;
  }
}
.box-scroll {
  height: calc(100vh - 380px);
}
.mains-content {
  // padding: 16px;
  background: #fff;
  padding-bottom: 16px;
  .tops-title {
    box-sizing: border-box;
  }
 
}
</style>